import customers from './customers';

export default customers;
